import { sendPost } from "src/utils/sendApi";

export const preferencesApi = sendPost("v1/data/_preferences");

export const preferencesUpdateApi = sendPost(
  "v1/data/_update_preferences"
);